<template>
  <!-- マスター管理 -->
  <div id="MasterMaint">
    <div id="container">
      <masterNavi v-if="isMaint" v-bind:pageid='"MasterMaint"'></masterNavi>
      <div class="labelTitle lable">マスター管理</div>
      <template  v-if="isMaint">
        <div class="labelTitle lable">住所マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadAddress">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">住所マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadAddress"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">住所マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">支店マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadOffice">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">支店マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadOffice"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">支店マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">得意先マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadCustomer">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">得意先マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadCustomer"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">得意先マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">従業員マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadStaff">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">従業員マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadStaff"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">従業員マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
        <div class="labelTitle lable">品目マスター</div>
        <ul class="link-area">
          <li>
            <b-field class="file">
              <b-upload v-model="targetFile" @input="uploadItem">
                <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">品目マスター<br>アップロード</div></div></a>
              </b-upload>
            </b-field>
          </li>
          <li>
            <a><div class="buttonArea" @click="downloadItem"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">品目マスター<br>ダウンロード</div></div></a>
          </li>
        </ul>
      </template>
      <div class="labelTitle lable">患者コードマスター</div>
      <ul class="link-area">
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadPatientCode">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">患者コードマスター<br>アップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadPatientCode"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">患者コードマスター<br>ダウンロード</div></div></a>
        </li>
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadTransferPatientCode">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">再開患者コード<br>マスターアップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadTransferPatientCode"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">再開患者コード<br>マスターダウンロード</div></div></a>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadChangePatientCode"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">処方変更患者コード<br>マスターダウンロード</div></div></a>
        </li>
        <li>
          <a><div class="buttonArea" @click="getPatientCodeUploadErrorList"><b-icon icon="download-box-outline" size="is-large"/><div class="buttonName">キャンセルデータ取得</div></div></a>
        </li>
        <li>
          <a><div class="buttonArea" @click="getPatientCodeFileUploadErrorList(true)"><b-icon icon="download-box-outline" size="is-large"/><div class="buttonName">エラーリスト取得</div></div></a>
        </li>
      </ul>
      <div class="labelTitle lable">使用明細</div>
      <ul class="link-area">
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadUsageDetails">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">使用明細<br>アップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
      </ul>
      <div class="labelTitle lable">得意先担当マスター</div>
      <ul class="link-area">
        <li>
          <b-field class="file">
            <b-upload v-model="targetFile" @input="uploadCustomerStaffRelation">
              <a><div class="buttonArea"><b-icon icon="cloud-upload-outline" size="is-large" /><div class="buttonName">得意先担当マスター<br>アップロード</div></div></a>
            </b-upload>
          </b-field>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadCustomerStaffRelation"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">得意先担当マスター<br>ダウンロード</div></div></a>
        </li>
      </ul>
      <div class="labelTitle lable">患者動態マスター</div>
      <ul class="link-area">
        <li>
          <a><div class="buttonArea" @click="downloadKanjaDotai(true)"><b-icon icon="file-download-outline" size="is-large"/><div class="buttonName">（新規）患者動態<br>ダウンロード</div></div></a>
        </li>
        <li>
          <a><div class="buttonArea" @click="downloadKanjaDotai(false)"><b-icon icon="file-download" size="is-large"/><div class="buttonName">（更新）患者動態<br>ダウンロード</div></div></a>
        </li>
        <li>
          <a><div class="buttonArea" @click="getDotaiDownloadErrorList(true)"><b-icon icon="download-box-outline" size="is-large"/><div class="buttonName">エラーリスト取得</div></div></a>
        </li>
      </ul>
      <!-- 取得結果 -->
      <div v-show="patientCodeErrorList.length>0">
        <div class="labelTitle lable">患者コードマスターキャンセルデータ取得</div>
        <h1 style="text-align:left;color:red;">&nbsp;&nbsp;明細をご確認ください。</h1>
        <!-- 患者コードアップロードキャンセルリスト -->
        <b-table
          :data="patientCodeErrorList"
          :columns="patientCodeErrorListColumns"
          :paginated="true"
          per-page="20"
          pagination-position="both"
          default-sort="uploadPatientCodeErrorDate"
          default-sort-direction="desc"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page">
          <template slot-scope="props">
            <td>{{props.row.newFlag?"新規":"更新"}}</td>
            <td>{{props.row.receptionNo}}</td>
            <td>{{props.row.patientCode}}</td>
            <td>{{props.row.patientName}}</td>
            <td>{{props.row.uploadPatientCodeErrorDate}}</td>
            <td>
              <b-button
                class="clearBtn"
                icon-left="eraser"
                @click="setUploadPatientCodeCancelDataDelete(props.row.id, props.row.receptionNo)">
              </b-button>
            </td>
          </template>
        </b-table>
      </div>
      <div v-show="dotaiErrorList.length>0">
        <div class="labelTitle lable">患者動態マスターエラーリスト取得</div>
        <h1 style="text-align:left;color:red;">&nbsp;&nbsp;明細をご確認ください。</h1>
        <!-- 患者動態エラーリスト -->
        <b-table
          :data="dotaiErrorList"
          :columns="dotaiErrorListColumns"
          :paginated="true"
          per-page="20"
          pagination-position="both"
          default-sort="receptionNo"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page">
          <template slot-scope="props">
            <td>{{props.row.newFlag?"新規":"更新"}}</td>
            <td>{{props.row.receptionNo}}</td>
            <td>{{props.row.PARNR}}</td>
            <td>{{props.row.NAMEK}}</td>
            <td>{{props.row.MATNR}}</td>
            <td>{{props.row.SERNR}}</td>
          </template>
        </b-table>
      </div>
      <div v-show="patientCodeFileErrorList.length > 0">
        <div class="labelTitle lable">患者コードマスターエラーリスト取得</div>
        <h1 style="text-align:left;color:red;">&nbsp;&nbsp;明細をご確認ください。</h1>
        <!-- 患者コードファイルアップロードエラーリスト -->
        <b-table
          :data="patientCodeFileErrorList"
          :columns="patientCodeFileErrorListColumns"
          :paginated="true"
          per-page="20"
          pagination-position="both"
          default-sort="errorDate"
          default-sort-direction="desc"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page">
          <template slot-scope="props">
            <td v-if="props.row.carvingFlag === null || (props.row.carvingFlag != 0 && props.row.carvingFlag != 1)"></td>
            <td v-else>{{props.row.carvingFlag == 0?"新規":"再開"}}</td>
            <td>{{props.row.receptionNo}}</td>
            <td>{{props.row.patientName}}</td>
            <td>{{props.row.errorDate}}</td>
            <td>{{props.row.fileName}}</td>
            <td>
              <b-button
                class="clearBtn"
                icon-left="eraser"
                @click="setUploadPatientCodeErrorDataDelete(props.row.id, props.row.receptionNo)">
              </b-button>
            </td>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "MasterMaint",
  props: {
    isMaint:{default:true}
  },
  methods: {
    uploadAddress: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.uploadMaintenanceAddressMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadOffice: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceBranchMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadCustomer: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceCustomerMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadStaff: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceEmployeeMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadItem: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceItemMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    uploadPatientCode: function(){
      var _this = this;
      _this.uploadErrorMessage = "";
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenancePatientCodeMasterPOST({
              upfile: _this.targetFile,
          })
        },
        function(result) {
          // upload成功後
          _this.targetFile = null;
          _this.uploadErrorMessage = result.obj.message;
          _this.getPatientCodeFileUploadErrorList();
        },
        this.errorSave,
      );
    },
    uploadTransferPatientCode: function(){
      var _this = this;
      _this.uploadErrorMessage = "";
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadMaintenanceTransferPatientCodeMasterPOST({
              upfile: _this.targetFile,
          })
        },
        function(result) {
          // upload成功後
          _this.targetFile = null;
          _this.uploadErrorMessage = result.obj.message;
          _this.getPatientCodeFileUploadErrorList();
        },
        this.errorSave,
      );
    },
    uploadUsageDetails: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadUsageDetailsMasterPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      );
    },
    uploadCustomerStaffRelation: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.internalMaintenance.UploadCustomerStaffRelationPOST({
              upfile: _this.targetFile,
          })
        },
        this.successSave,
        this.errorSave,
      );
    },
    downloadAddress: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceAddressMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadOffice: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceBranchMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadCustomer: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceCustomerMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadStaff: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceEmployeeMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadItem: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceItemMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadPatientCode: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenancePatientCodeMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadTransferPatientCode: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceTransferPatientCodeMasterPOST()
        },
        this.errorDownload
      );
    },
    downloadKanjaDotai: function(newFlag){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceKanjaDotaiMasterPOST({
            body:{newFlag:newFlag}
          })
        },
        this.errorDownload,
        this.getDotaiDownloadErrorList
      );
    },
    getDotaiDownloadErrorList: function(clickButton) {
      this.clickGetDotaiDownloadErrorList = clickButton
      // 診療科コードリスト取得
      var excuteApi = this.getDotaiDownloadErrorListPOST;
      var successCallBack = this.getDotaiDownloadErrorListSuccess;
      var errorCallBack = this.getDotaiDownloadErrorListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getDotaiDownloadErrorListPOST: function(client) {
      return client.apis.internalMaintenance.getDotaiDownloadErrorListPOST();
    },
    getDotaiDownloadErrorListSuccess: function(result) {
      let errorMsg = result.obj.dotaiDownloadErrorMsg
      let errorList = result.obj.dotaiDownloadErrorList
      this.dotaiErrorList = [];
      this.patientCodeErrorList = [];
      this.patientCodeFileErrorList = [];

      // エラーリスト取得ボタン押下時
      if (this.clickGetDotaiDownloadErrorList) {
        this.clickGetDotaiDownloadErrorList = false;
        if (errorMsg) {
          this.dotaiErrorList = errorList;
        }
      // 患者動態ダウンロードボタン押下時
      } else {
        if (errorMsg) {
          this.showErrorMessage(errorMsg);
          this.dotaiErrorList = errorList;
        }
      }
    },
    getDotaiDownloadErrorListPOSTError: function() {
      this.errorDownload;
    },
    downloadCustomerStaffRelation: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadCustomerStaffRelationPOST()
        },
        this.errorDownload
      );
    },
    downloadChangePatientCode: function(){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.DownloadMaintenanceChangePatientCodeMasterPOST()
        },
        this.errorDownload
      );
    },
    getPatientCodeUploadErrorList: function(client) {
      var excuteApi = this.getPatientCodeUploadErrorListPOST;
      var successCallBack = this.getPatientCodeUploadErrorListSuccess;
      var errorCallBack = this.getPatientCodeUploadErrorListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPatientCodeUploadErrorListPOST: function(client) {
      return client.apis.internalMaintenance.getPatientCodeUploadErrorListPOST();
    },
    getPatientCodeUploadErrorListSuccess: function(result) {
      let errorMsg = result.obj.message
      let errorList = result.obj.errorList
      this.dotaiErrorList = [];
      this.patientCodeErrorList = [];
      this.patientCodeFileErrorList = [];

      this.patientCodeErrorList = errorList;
    },
    getPatientCodeUploadErrorListPOSTError: function() {
      this.errorSave;
    },
    setUploadPatientCodeCancelDataDelete: function(requestId, receptionNo) {
      // キャンセルデータを削除する。
      this.apiCall(function(client){
          return client.apis.internalMaintenance.setUploadPatientCodeCancelDataDeletePOST({
            body:{
              requestId   : requestId,
              receptionNo : receptionNo,
            }
          })
        },
        this.setUploadPatientCodeCancelDataDeleteSuccess,
        this.showErrorMessage
      );
    },
    setUploadPatientCodeCancelDataDeleteSuccess: function(result){
      // 削除後、再検索
      this.showSuccess(result, this.getPatientCodeUploadErrorList)
    },
    getPatientCodeFileUploadErrorList: function(clickButton) {
      this.clickGetPatientCodeFileUploadErrorList = clickButton;

      var excuteApi = this.getPatientCodeFileUploadErrorListPOST;
      var successCallBack = this.getPatientCodeFileUploadErrorListPOSTSuccess;
      var errorCallBack = this.getPatientCodeFileUploadErrorListPOSTError;
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPatientCodeFileUploadErrorListPOST: function(client) {
      return client.apis.internalMaintenance.getPatientCodeFileUploadErrorListPOST();
    },
    getPatientCodeFileUploadErrorListPOSTSuccess: function(result) {
      let errorMsg = result.obj.patientCodeFileUploadErrorMsg;
      // 過去データも含めアップロードエラーとなっているデータ全件
      let errorList = result.obj.patientCodeFileUploadErrorList;
      // 今回のアップロードでエラーがあった場合、エラーファイル出力＋エラーリスト表示（ダウンロードフラグfalse）
      let patientCodeFileUploadErrorDownloadCount = result.obj.patientCodeFileUploadErrorDownloadCount;

      // エラーリスト＆キャンセルデータ初期化
      this.dotaiErrorList = [];
      this.patientCodeErrorList = [];
      this.patientCodeFileErrorList = [];

      // 患者コードファイルアップロードエラーリスト取得ボタン押下時
      if (this.clickGetPatientCodeFileUploadErrorList) {
        this.clickGetPatientCodeFileUploadErrorList = false;
        if (errorList.length > 0) {
          this.patientCodeFileErrorList = errorList;
        }
      } else {
        // 患者コードファイルアップロードボタン押下時にエラーがある、かつ過去エラーデータもある場合：エラーリスト取得＆エラーファイル出力
        if (errorList.length > 0 && patientCodeFileUploadErrorDownloadCount > 0) {
          var message = this.uploadErrorMessage ? this.uploadErrorMessage + "\n\n" + errorMsg : errorMsg
          console.log(message)
          this.showErrorMessage(message);
          this.patientCodeFileErrorList = errorList;
          // ★エラーファイル出力API newFlagとってくる
          this.downloadPatientUploadErrorList(errorList[0].newFlag);
        } else if (errorList.length > 0 && patientCodeFileUploadErrorDownloadCount == 0) {
          // 患者コードファイルアップロードボタン押下時にエラーがない、かつ過去エラーデータもある場合：エラーリスト取得のみ
          this.patientCodeFileErrorList = errorList;
          if (!this.uploadErrorMessage) {
            this.showErrorMessage('ファイルアップロードに成功しました。');
          } else {
            this.showErrorMessage(this.uploadErrorMessage);
          }
        } else {
          // 患者コードファイルアップロードボタン押下時にエラーがない場合
          if (!this.uploadErrorMessage) {
            this.showErrorMessage('ファイルアップロードに成功しました。');
          } else {
            this.showErrorMessage(this.uploadErrorMessage);
          }
        }
      }
    },
    getPatientCodeFileUploadErrorListPOSTError: function() {
      this.errorDownload;
    },
    downloadPatientUploadErrorList: function(newFlag){
      this.downloadApiCall(function(client){
          return client.apis.internalMaintenance.downloadPatientUploadErrorListPOST({
            body:{newFlag:newFlag}
          });
        },
        this.errorDownload,
      );
    },
    setUploadPatientCodeErrorDataDelete: function(requestId, receptionNo) {
      // 患者コードアップロードエラーデータを削除する
      this.$dialog.confirm({
        title: " ",
        message: `受付番号"${receptionNo}"のエラーデータを削除しますか？`,
        confirmText:"OK",
        cancelText: "キャンセル",
        onConfirm: async() => {
          //API呼出し
          return this.setUploadPatientCodeErrorDataDeletePOST(requestId, receptionNo);
        }
      });
    },
    setUploadPatientCodeErrorDataDeletePOST: function(requestId, receptionNo) {
      const THIS = this;
      this.apiCall(
        (client) => {
          return client.apis.internalMaintenance.setUploadPatientCodeErrorDataDeletePOST({
            body:{
              requestId   : requestId,
              receptionNo : receptionNo,
            }
          });
        },
        (result) => {
          THIS.setUploadPatientCodeErrorDataDeletePOSTSuccess(result);
        },
        (error) => {
          THIS.setUploadPatientCodeErrorDataDeletePOSTError(error);
        }
      );
    },
    setUploadPatientCodeErrorDataDeletePOSTSuccess: function(result){
      // 削除＋エラー再検索
      this.getPatientCodeFileUploadErrorList(true);
      this.showSuccess(result);
    },
    setUploadPatientCodeErrorDataDeletePOSTError: function(error){
      // エラーメッセージ表示
      this.showErrorMessage(error);
    },
    successSave: function(result){
      this.targetFile = null;
      this.showSuccess(result);
    },
    errorSave: function(result){
      this.targetFile = null;
      this.showErrorMessage(result);
    },
    errorDownload: function(result){
      this.showErrorMessage(result);
    }
  },
  mounted: function() {
    // this.getDotaiDownloadErrorList();
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isAdmin = roleId == role.role_admin;
    return {
      targetFile: {},
      uploadErrorMessage: "",
      isAdmin,
      dotaiErrorList: [],
      dotaiErrorListColumns: [
        {field: "newFlag", label: "新規/更新", sortable: true},
        {field: "receptionNo", label: "受付番号", sortable: true},
        {field: "PARNR", label: "患者コード", sortable: true},
        {field: "NAMEK", label: "患者名", sortable: true},
        {field: "MATNR", label: "品目コード", sortable: true},
        {field: "SERNR", label: "シリアル", sortable: true},
      ],
      clickGetDotaiDownloadErrorList: false,
      patientCodeErrorList: [],
      patientCodeErrorListColumns: [
        {field: "newFlag"                   , label: "新規/更新"            , sortable: true},
        {field: "receptionNo"               , label: "受付番号"             , sortable: true},
        {field: "patientCode"               , label: "アップロード患者コード", sortable: true},
        {field: "patientName"               , label: "患者名"               , sortable: true},
        {field: "uploadPatientCodeErrorDate", label: "エラー日時"           , sortable: true},
        {field: "delete_btn"                , label: ""                    , sortable: false},
      ],
      clickGetPatientCodeUploadErrorList: false,
      patientCodeFileErrorList: [],
      patientCodeFileErrorListColumns: [
        {field: "carvingFlag", label: "新規/再開", sortable: true},
        {field: "receptionNo", label: "受付番号", sortable: true},
        {field: "patientName", label: "患者名", sortable: true},
        {field: "errorDate", label: "エラー日時", sortable: true},
        {field: "fileName", label: "エラーファイル名", sortable: true},
        {field: "delete_btn", label: "", sortable: false},
      ],
      clickGetPatientCodeFileUploadErrorList: false,
    };
  },
  components: {
    masterNavi: naviBar,
  }
};
</script>

<style lang="scss" >
.clearBtn {
  margin-left: 5px;
  height: 27px !important;
  width: 27px !important;
}
ul.link-area {
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
ul.link-area>li {
    margin:10px;
}
a .buttonArea {
    display: flex;
    align-items:center;
    padding: 10px;
    height: 100px;
    width: 250px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
    );
    color:whitesmoke;
}
a .buttonArea:hover{
    color:whitesmoke;
}
a .buttonArea div {
    margin-left:10px;
    padding-right:10px;
}
.buttonName {
  width: 170px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/master/MasterMaint.vue